module.exports = __webpack_public_path__ + "static/media/ic-dashboard.90b8922b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-dashboard.svg
// module id = 617
// module chunks = 14